import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { DatetimeButtonComponent } from './component/datetime-button/datetime-button.component';
import { NgxPhotoEditorComponent } from './component/ngx-photo-editor/ngx-photo-editor.component';
import { FileCameraComponent } from './component/file-camera/file-camera.component';
import { NotificationComponent } from './component/notification/notification.component';
import { SelectSearchComponent } from './component/select-search/select-search.component';
import { SelectSearchMultipleComponent } from './component/select-search-multiple/select-search-multiple.component';
import { EmergencyComponent } from './component/emergency/emergency.component';
import { EventFicheComponent } from './agenda/components/event-fiche/event-fiche.component';
import { ReportAbuseComponent } from './component/report-abuse/report-abuse.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PinchZoomComponent } from '@meddv/ngx-pinch-zoom';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { SanitizeHtmlPipe } from './pipe/sanitize-html.pipe';
import { VoiceRecognitionComponent } from './component/voice-recognition/voice-recognition.component';
import { AnimalSelectComponent } from './component/animal-select/animal-select.component';


@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterLink,
    DatetimeButtonComponent,
    NgxPhotoEditorComponent,
    FileCameraComponent,
    NotificationComponent,
    SelectSearchComponent,
    SelectSearchMultipleComponent,
    EmergencyComponent,
    EventFicheComponent,
    ReportAbuseComponent,
    NgxDatatableModule,
    PickerModule,
    PinchZoomComponent,
    SanitizeHtmlPipe,
    VoiceRecognitionComponent,
    AnimalSelectComponent,
  ],
  exports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterLink,
    DatetimeButtonComponent,
    NgxPhotoEditorComponent,
    FileCameraComponent,
    NotificationComponent,
    SelectSearchComponent,
    SelectSearchMultipleComponent,
    EmergencyComponent,
    EventFicheComponent,
    ReportAbuseComponent,
    NgxDatatableModule,
    PickerModule,
    PinchZoomComponent,
    SanitizeHtmlPipe,
    VoiceRecognitionComponent,
    AnimalSelectComponent,
  ]
})
export class IonicSharedModule { }

